import React = require('react');

export const MedicalInformationControlVariant = () => {
  return (
    <div className="medical-card">
      <div className="medical-card-right">
        <h2>Medical Declaration</h2>
        <p>
          We’ll ask you a few questions about health and medical history.
        </p>
        <p>
          This includes illnesses, injuries, or medical conditions that are diagnosed or under
          investigation - for example you're waiting for tests, results, or treatment.
        </p>
        <div className="medical-card-bottom">
          <p>
            These questions help us make sure your cover fits your needs and protects you if
            something unexpected happens. If any information is missing or incorrect, it could
            affect a future claim.
          </p>
          <img className="annie-non-mobile-img" src={require('../../img/annie_thinking_left_face.png')} alt="Annie thinking"/>
          <img className="annie-mobile-img" src={require('../../img/annie_thinking_left_face_mobile.png')} alt="Annie thinking"/>
        </div>
      </div>
    </div>
  )
}
